<template>
  <div class="main-wrapper">
    <h1>About Us</h1>
    <div id="values" class="vision-mission">
      <h2>Vision and Missions</h2>
      <div id="vision" class="values">
        <div>
          <img id="target" src="../assets/icons/target.png" alt="Vision">
        </div>
        <div>
          <h3>Our Vision</h3>
          <p>To transform the resource industry through digitalization. </p>
        </div>    
      </div>
      <div class="hr"></div>
      <div class="values">
        <div>
          <h3>Our Missions</h3>
          <ul>
              <li>Provide solutions for automating the digitization of analog data.</li>
              <li>Utilize data analytics to mine digital data for information.</li>
              <li>Leverage machine learning to simplify time-intensive tasks.</li>
          </ul>
        </div>
        <div>
          <img id="mountain" src="../assets/icons/flag.png" alt="Mission">
        </div>
      </div>
      <div class="pt-3">
        <h2>What We Do</h2>
        <div class="workflow container-fluid">
          <div class="workflow-item">
            <img id="binary" src="../assets/icons/binary.png" alt="Binary">
            <p>So you've got masses of data and don't know how to deal with them?</p>
          </div>
          <div class="workflow-item">
            <img id="database" src="../assets/icons/database.png" alt="Database">
            <p>We'll sort them out for you.</p>
          </div>
          <div class="workflow-item">
            <img id="graph" src="../assets/icons/laptop.png" alt="Graph">
            <p>Then present them back in a way that you can make sense of them.</p>
          </div>
        </div>
        <!-- <div>
          <img src="../assets/images/radix workflow.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.values {
  display: flex;
  padding-top: 10%;
  padding-bottom: 10%;
}

.values div {
  width: 50%;
}

.vision-mission {
  padding-top: 5%;
}

.main-wrapper{
  color: white;
}

.workflow {
  display: flex;
  padding-top: 10%;
}

#target, #mountain, #binary, #database, #graph{
  filter: invert(100%);
}

#target, #mountain{
  width: 25%;
}

.workflow img {
  width: 40%;
  margin-bottom: 2rem;
}

.hr {
  border-top: 1px solid white;
}

ul {
  text-align: left;
}

hr {
  border-top: 0.5px solid white;
}

h3 {
  padding-top: 1rem;
}

@media only screen and (max-width: 700px) {
  .values {
    display: block;
    
  }

  .values div {
    width: 100%;
  }

  #target, #mountain{
    width: 100px;
  }

  .workflow {
    display: block;
  }

  .workflow img {
    width: 30%;
    margin-bottom: 2rem;
  }

  .workflow-item{
    margin: 3rem 1rem;
  }
}
</style>